import { combineReducers } from 'redux'
import Tabs from './tabs'

export default combineReducers({
  Tabs
})